import React from "react";

export default function Privacy() {
  const updated = "August 2, 2026";
  return (
    <main data-testid="privacy-page" className="pt-28 pb-28 min-h-screen relative z-10">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="overline text-[#9A7420] mb-3">Legal</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mb-4">Privacy Policy</h1>
        <p className="text-[#8B8494] text-sm mb-14">Last updated {updated}</p>

        <div className="prose prose-neutral max-w-none text-[#3a3541] leading-relaxed space-y-10">
          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Who we are</h2>
            <p>
              Women Heaven Med Spa (&quot;Women Heaven,&quot; &quot;we,&quot; &quot;us&quot;) operates womenheaven.com and provides
              in-person aesthetic and wellness services in Santa Clarita, California. This policy explains
              what information we collect, how we use it, and the rights you have over that information.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Information we collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><b>Account information</b> you provide when you register: name, email, phone number, and a password (stored as a bcrypt hash — never in plain text).</li>
              <li><b>Booking information</b>: the service you selected, date, time, and any notes you add.</li>
              <li><b>Consultation requests</b>: the contact form fields you submit.</li>
              <li><b>Payment information</b>: processed entirely by Stripe. We never see or store your card number. We do store the shipping address you provide at checkout so we can fulfil your product order.</li>
              <li><b>Selfie for AI Skin Analysis</b>: your uploaded image is sent to our AI provider (OpenAI, via Emergent) for analysis and is <b>immediately discarded</b>. We do not save the image on our servers or in our database. Only the numerical results and recommendations are saved to your account.</li>
              <li><b>Usage data</b>: basic server logs (IP, browser, path) retained for security and troubleshooting.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">SMS text messages</h2>
            <p>
              If you book a Wet Cupping appointment, we send text messages to the phone number you provide, for the sole purpose of delivering treatment-specific instructions:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>One <b>pre-care</b> message when your appointment is booked or confirmed.</li>
              <li>One <b>after-care</b> message once your treatment is marked complete.</li>
            </ul>
            <p className="mt-3">
              Message frequency is limited to no more than two messages per appointment. Message and data rates may apply. Consent to receive these messages is not a condition of any purchase. You can opt out at any time by replying <b>STOP</b> to any message we send, or by contacting the spa directly. For help, reply <b>HELP</b> or email Womenheaven@outlook.com. We do not use SMS for marketing or promotional messages, and we do not sell, rent, or share phone numbers with third parties for marketing purposes.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">How we use your information</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide the services you request (bookings, product orders, skin analysis, consultations).</li>
              <li>To communicate with you about your appointments, orders, and account (email and, for wet cupping only, SMS).</li>
              <li>To fulfil product orders — for Atomy products, we forward your shipping address to Atomy so they can ship to you.</li>
              <li>To secure our site and prevent abuse.</li>
              <li>To comply with legal obligations.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Who we share information with</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><b>Stripe</b> — payment processing.</li>
              <li><b>Twilio</b> — SMS delivery for Wet Cupping instructions.</li>
              <li><b>Resend</b> — transactional emails (booking confirmations, order updates).</li>
              <li><b>OpenAI (via Emergent)</b> — AI Skin Analysis. The image is sent for analysis and discarded; no personal identifiers are attached.</li>
              <li><b>Atomy</b> — the shipping address you provide at checkout is used to place your order with the manufacturer.</li>
            </ul>
            <p className="mt-3">We do not sell your personal information.</p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Medical / HIPAA note</h2>
            <p>
              Women Heaven provides cosmetic and wellness services. Our AI Skin Analysis is for cosmetic guidance only and is not a medical diagnosis. Because our third-party AI vendor does not offer a HIPAA Business Associate Agreement, we intentionally do <b>not</b> store selfie images on our systems. If you have protected health information you wish to discuss, please do so with your licensed provider in person.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Your rights</h2>
            <p>
              You can request access, correction, or deletion of your personal information at any time by emailing <a className="text-[#9A7420] underline" href="mailto:Womenheaven@outlook.com">Womenheaven@outlook.com</a>. California residents have additional rights under the CCPA/CPRA. We will respond within 30 days.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Cookies</h2>
            <p>
              We use only strictly necessary cookies (session and authentication). We do not use advertising or cross-site tracking cookies.
            </p>
          </section>

          <section>
            <h2 className="font-display text-3xl text-[#2B2340] mb-3">Contact</h2>
            <p>
              Questions about this policy? Email <a className="text-[#9A7420] underline" href="mailto:Womenheaven@outlook.com">Womenheaven@outlook.com</a> or call +1 (661) 666-8041.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
